import { render, staticRenderFns } from "./SingleMailComposer.vue?vue&type=template&id=80a9d4f6&"
import script from "./SingleMailComposer.vue?vue&type=script&lang=js&"
export * from "./SingleMailComposer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports